export default __webpack_public_path__ + "4f5bb07425588ef1fb40d21b057f2efb.png";